import jQuery from 'jquery';
import moment from 'moment';
import { Settings } from './Settings';

export default class NewsPresenter {
  constructor() {
    this.container = $('#posts');
  }

  render(model) {
    const container = jQuery('#posts');
    const content = model.data.map((element) => {
      if (!element.Title) {
        return '';
      }
      return this.renderItem(element)
    }).join('')
    container.append(content);
  }


  append(model) {
    const content = model.data.map((element) => {
      if (!element.Title) {
        return '';
      }
      return this.renderItem(element);
    }).join('')
    const $content = $(content);
    $content.appendTo('#posts');
    const appended = $content.toArray();
    return appended;
  }

  appendItem(news) {
    const content = this.renderItem(news);
    this.container.append(content);
  }

  renderItem(item) {  
    const dt = moment.utc(item.Date).local().format('DD.MM.yyyy');
    return `<div class="entry clearfix">
                    <div class="entry-timeline">
                        <div class="timeline-divider"></div>
                    </div>
                    <div class="entry-title">            
                        <h2>
                            ${item.Title || ''}
                        </h2>
                    </div>
                    <ul class="entry-meta clearfix">
                        <li><i class="icon-calendar3"></i>${dt}</li>
                        <li><i class="icon-user"></i>${item.UserName}</li>
                    </ul>
                    <div class="entry-content">
                        <p>${item.Description || ''}</p>
                        <div class="more-link"><a href="/${Settings.language()}/News/Details/${item.NewsId}" class="more-link">${this.getNextLiteral()}...</a></div>
                    </div>
                </div>`;
  }

  renderTimeline() {
    var newsWrapper = $('#posts');
    newsWrapper.isotope({
      itemSelector: '.entry',
      layoutMode: 'fitRows'
    });

    SEMICOLON.documentOnLoad.init();
    SEMICOLON.initialize.resizeVideos();
    newsWrapper.fitVids();
    newsWrapper.isotope('layout');
    SEMICOLON.initialize.blogTimelineEntries();
  }

  getNextLiteral() {
    if (Settings.language() === 'en') {
      return 'more'
    }

    if (Settings.language() === 'ru') {
      return 'далее'
    }

    return '';
  }
}